import { memo } from "react";
import { PAYMENT_OPTIONS } from "services/api/sales/listings/consts";
import { MarketplaceDetails } from "services/api/sales/listings/types";
import { ChipToggle } from "ui/modules/sales/pages/listings/components/ListingEditCard/components/MarketplaceStep/primitives";
import { EmptyHint, Section } from "./primitives";

interface Props {
  details?: MarketplaceDetails | null;
}

const importLabel = (v: string | null | undefined) => {
  if (v === "with") return "Cijena uključuje sve troškove uvoza/unosa";
  if (v === "without") return "Cijena je bez troškova uvoza/unosa";
  return null;
};

// Sekcija "Mogućnost plaćanja" — info pasus o uvozu + chipovi za izabrane
// opcije plaćanja.
const ListingPayment: React.FC<Props> = ({ details }) => {
  if (!details) {
    return (
      <Section title="Mogućnost plaćanja">
        <EmptyHint text="Mogućnosti plaćanja još nisu unesene za ovaj oglas." />
      </Section>
    );
  }

  const importText = importLabel(details.priceIncludesImport);

  return (
    <Section title="Mogućnost plaćanja">
      {importText && (
        <div className="text-sm text-slate-600 mb-3">{importText}</div>
      )}
      {/* Isti čipovi kao na unosu, samo bez klika — vide se sve opcije, odabrane su označene. */}
      <div className="flex flex-wrap gap-2">
        {PAYMENT_OPTIONS.map((opt) => (
          <ChipToggle
            key={opt.code}
            label={opt.label}
            selected={details.paymentOptions[opt.code] === true}
            readOnly
          />
        ))}
      </div>
    </Section>
  );
};

export default memo(ListingPayment);
